import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import ProductCountries from "../../Components/Header/ProductCountries";
import formatPrice from "../../Components/formatPrice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import GradeIcon from "@mui/icons-material/Grade";
import Skeleton from "@material-ui/lab/Skeleton";
import FetchPriceLoader from "../../Components/FetchPriceLoader";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import "./ApisSearchResults.scss";
var moment = require("moment");

function ApisSearchResults({ getProducts, userData, isFetching, productUpdates }) {
  const { languageCode } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const location = useLocation();
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0);
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return (
          <>
            {t("delivery_by")} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), "days").format("Do")}
          </>
        );
      } else {
        return (
          <>
            {t("delivery_by")} {moment().add(Number(deliveryDaya), "days").format("Do MMM")}
          </>
        );
      }
    }
    if (Number(deliveryDaya) > 0) {
      // return getTimeline()
      return `${t("delivery_by")} ${moment().add(14, "days").format("Do MMM")}`;
    } else {
      return `${t("delivery_by")} ${moment().add(14, "days").format("Do MMM")}`;
    }
  }

  function productTitle(title) {
    return title
      ?.replace(/[^A-Za-z0-9]/g, " ")
      ?.replace(/[^\w\s]/gi, " ")
      ?.replace(/ /g, "-");
  }

  const handleError = (e) => {
    console.error("Error loading image:", e.target.src);
    e.target.src = "https://cdn.ebtida.com/1705315901965-Image-not-found.jpg";
  };

  const beforeLoadHandler = () => (
    <img className="img-item" src="https://cdn.ebtida.com/1705315901965-Image-not-found.jpg" />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false;
    } else if (rating === "0") {
      return false;
    } else if (!rating) {
      return false;
    } else {
      return true;
    }
  }

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12, 26];
  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid;
    } else {
      return id;
    }
  }

  function checkIfAnyNumber(badge) {
    return /\d|×/.test(badge);
  }

  function removeDuplicates(inputString) {
    const lowerInput = inputString?.toLowerCase();
    if (lowerInput?.includes("prime") || lowerInput?.includes("amazon")) {
      return false;
    }
    const wordsArray = inputString?.split(/\s+/);
    const uniqueWords = [...new Set(wordsArray)];
    const result = uniqueWords?.join(" ");
    return result;
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false;
    }
    if (fetch && country != itemCountry) {
      return true;
    }
    return false;
  }

  return (
    <>
      {getProducts?.map((item, i) => {
        const selectedShipping = productUpdates?.find((s) => s.id === item.id);
        const prices = item?.prices ? item?.prices : selectedShipping?.prices;
        const inStock = item?.in_stock ? item?.in_stock : selectedShipping?.in_stock;
        const brand = item?.brand ? item?.brand : selectedShipping?.brand;
        const dealbBadge = item?.deal_badge ? item?.deal_badge : selectedShipping?.deal_badge;
        return (
          <div className="col-md-3 lx-col" style={{ padding: "5px" }} key={i}>
            <Link
              className="lx-card"
              to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}
            >
              <div className="lx-card__media">
                {checkIfAnyNumber(dealbBadge)
                  ? ""
                  : removeDuplicates(dealbBadge) && <div className="lx-ribbon">{removeDuplicates(dealbBadge)}</div>}

                {item?.prices?.deal_value && (
                  <div className="lx-flash" aria-label={t("deal")}>
                    <FlashOnIcon style={{ fontSize: "1rem" }} />
                  </div>
                )}

                <LazyLoadImage
                  delayTime={100}
                  key={i}
                  alt={item?.title}
                  effect="blur"
                  className="lx-card__img"
                  src={item?.image}
                  onError={handleError}
                  beforeLoad={beforeLoadHandler}
                />

                <div className="lx-delivery">
                  <span className={isMobcreen ? `lx-delivery__pill` : `lx-delivery__text`}>
                    {getDeliverydays(item.estimated_delivery)}
                  </span>
                </div>
              </div>

              <div className="lx-card__body">
                <h4 className="lx-title">{item?.title?.replace(/[^\w\s.,'/:]/gi, " ")}</h4>

                <div className="lx-meta">
                  {brand && <span className="lx-brand">{brand}</span>}
                  {ratingFucn(item?.rating) && (
                    <span className="lx-rating">
                      <span className="lx-rating__value">{item?.rating}</span>
                      <GradeIcon className="lx-rating__icon" />
                    </span>
                  )}
                </div>

                <div className="lx-price-row">
                  {!item?.prices && !selectedShipping?.prices ? (
                    <FetchPriceLoader />
                  ) : (
                    <>
                      {Number(prices?.bdp) === 0 ? (
                        <span className="lx-chip lx-chip--muted">{t("Check Price")}</span>
                      ) : (
                        <>
                          {inStock ? (
                            <div className="lx-price">
                              <span className="lx-price__current">
                                {formatPrice(prices?.value, prices?.currency, 0)}
                              </span>
                              {prices?.deal_value && (
                                <span className="lx-price__was">{formatPrice(prices?.price, prices?.currency, 0)}</span>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>

                <div className="lx-footer">
                  {!item?.prices && !selectedShipping?.prices && (
                    <span className="lx-fetching">{t("Fetching best offer")}</span>
                  )}

                  {loadCountrySkeleton(isFetching, searchCountry, item?.country) ? (
                    <Skeleton style={{ height: "18px", width: "70px", borderRadius: "4px" }} />
                  ) : (
                    <div className="lx-origin">
                      <span className="lx-origin__label">{t("From")}</span>
                      <img
                        className="lx-origin__flag"
                        loading="lazy"
                        src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      <span className="lx-origin__name">{ProductCountries(item?.country)}</span>
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </>
  );
}

export default ApisSearchResults;
